import logox_TT from "../logox_TT.png"
import taghtiaLogo from "../TaghtiaLogoMain.png"
import {useEffect,useRef} from "react"
export default function Loader(){
    const loadingAnimation = useRef(null);
    useEffect(() => {
        setTimeout(() => {
            loadingAnimation.current.style.visibility = "visible";
            loadingAnimation.current.classList.add("fade-in");
        },1900)
    },[])
    return(
    <div className="loader">
        <div className="header">
            <img src={logox_TT} className="tt-logo"></img>
        </div>
        
        <div className="mid bounce-in-top">
            <img src={taghtiaLogo} className="taghtia-logo"></img>
            <h1 style={{fontSize:'2.8rem',marginBottom:'0.6em'}}>تغطية</h1>
            <div className="loading-animation" ref={loadingAnimation} style={{visibility: "hidden"}}>
            <p>Veuillez patienter</p>
            <div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            </div>
        </div>
    </div>)
}